export default "__VITE_ASSET__9L4dUX8a__"